export default "__VITE_ASSET__e8e2f07c__"